/**
 * Return a new array with the item at `fromIndex` moved by `delta` positions.
 * No-ops (same reference) when list is not an array, indexes are not integers,
 * indexes are out of range, or fromIndex === toIndex.
 *
 * @param {unknown} list
 * @param {unknown} fromIndex
 * @param {unknown} delta
 * @returns {unknown}
 */
export function moveArrayItem(list, fromIndex, delta) {
  if (!Array.isArray(list)) return list;
  if (!Number.isInteger(fromIndex) || !Number.isInteger(delta)) return list;

  const toIndex = fromIndex + delta;
  if (fromIndex === toIndex) return list;
  if (
    fromIndex < 0 ||
    fromIndex >= list.length ||
    toIndex < 0 ||
    toIndex >= list.length
  ) {
    return list;
  }

  const next = list.slice();
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);
  return next;
}
